import {createSlice, SliceCaseReducers} from '@reduxjs/toolkit'
import { RootState } from '../store'

interface ICartState{
    totalItemsInCart: number
    itemsInCart: {
        id:string
        quantity: number
        sellingPrice: number
        costPrice: number
    }[],
}

const Cart = createSlice<ICartState, SliceCaseReducers<ICartState>>({

    name:"cart",
    initialState:{
        totalItemsInCart: 0,
        itemsInCart: [],
    },
    reducers:{
        addToSale: (state, action)=>{
            state.itemsInCart.push(action.payload)
        },
        removeFromSale: (state, action)=>{
            state.itemsInCart = state.itemsInCart.filter((item)=>item.id !== action.payload.id)
        },
        clearCurrentSale: (state)=>{
            state.itemsInCart = []
        }
    }

})

export const cart = Cart.actions
export const selectSideMenuState = (state:RootState)=>state.cart
export const selectBarcodeEnabled = (state:RootState)=>state.cart

export default Cart.reducer